import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'
import { linkHref, trackInteraction } from 'frontend/shared/javascripts/tracking'

/**
 * A followed link of the subject area menu. Unpoly does this for its own links (boot/track_links); Inertia has
 * no such bus, so the menu calls it. Its element.id falls back to the class list.
 */
export function trackNav(event: MouseEvent) {
  const link = event.currentTarget as HTMLAnchorElement
  trackElementInteraction(link, 'click.link', { link: { href: link.href } })
}

/** An entry of the user menu or the navigation drawer. Logout is a form button, so its href is the form's action. */
export function trackNavigationItem(event: MouseEvent) {
  const element = event.currentTarget as HTMLElement
  const target =
    element instanceof HTMLAnchorElement ? element.href : element.closest('form')?.action

  // tracking: navigation.item_click
  trackInteraction(
    'click.link',
    { id: 'navigation.item_click', params: { link: { href: target && linkHref(target) } } },
    element,
  )
}
